module.exports = __webpack_public_path__ + "img/CasinoChangeName_48f04949f85601f7b07937dc47beb23d_20211014005704.5a429057.png";